module.exports = __webpack_public_path__ + "static/img/icon-3.bdaee5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/icon-3.png
// module id = Bntf
// module chunks = 0